export const setModalSubordinate = (state, val) => {
  state.modalSubordinate = val
}

export const setSideDev = (state, val) => {
  state.sideDev = val
}

export const setSideSettingProspek = (state, val) => {
  state.sideSettingProspek = val
}

export const setSideSettingActivity = (state, val) => {
  state.sideSettingActivity = val
}

export const setSideSettingCustomer = (state, val) => {
  state.sideSettingCustomer = val
}

export const setSideSettingEmployee = (state, val) => {
  state.sideSettingEmployee = val
}

export const setSidebar = (state, val) => {
  state.sidebar = val
}

export const setPrompt = (state, val) => {
  state.prompt = val
}

export const setScreenWidth = (state, val) => {
  state.screenWidth = val
}

export const setMenuSide = (state, val) => {
  state.menuSide = val
}

export const setNotif = (state, val) => {
  state.notif = val
}
